import { useInViewport } from 'ahooks';
import { noop } from 'lodash-es';
import {
  HTMLAttributes,
  MutableRefObject,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';

export function HighlightMsg({
  highlightKey,
  getRef,
  onVisibleChange = noop,
  ...otherProps
}: {
  highlightKey: number;
  getRef: (ref: MutableRefObject<HTMLDivElement | undefined>) => void;
  onVisibleChange?: (visible: boolean) => void;
} & HTMLAttributes<HTMLDivElement>) {
  const ref = useRef<HTMLDivElement>();

  const [inViewPort] = useInViewport(ref, {
    threshold: 0.8,
  });

  const [shouldHighlight, setShouldHighlight] = useState(false);
  useEffect(() => {
    if (highlightKey) {
      setShouldHighlight(true);
      setTimeout(() => {
        setShouldHighlight(false);
      }, 500);
    }
  }, [highlightKey]);

  const refsCurrent = {
    onVisibleChange,
  };
  const refs = useRef(refsCurrent);
  refs.current = refsCurrent;

  useLayoutEffect(() => {
    if (inViewPort === undefined) {
      return;
    }

    refs.current.onVisibleChange(inViewPort);
  }, [inViewPort]);

  return (
    <div
      className="relative p-2"
      style={{
        backgroundColor: shouldHighlight ? 'rgba(242, 161, 0, .25)' : 'transparent',
        transition: `background-color ${shouldHighlight ? 0 : 5}s`,
      }}
      ref={(div) => {
        ref.current = div || undefined;
        getRef(ref);
      }}
      {...otherProps}
    />
  );
}
